import React from 'react';
import { StyleSheet } from 'react-native';
import { Typography, Box } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { ColorScheme, theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';

export interface GenreTag {
    genre: string;
    onClickGenre?: (genre: string) => void;
    active?: boolean;
    tagStyle?: React.CSSProperties;
    tagtextStyle?: React.CSSProperties;
    additionalData?: string | number;
    groupLayout?: boolean;
    /** Warm pill chips for Watch recommendations (primary active, dark inactive). */
    editorialPill?: boolean;
}

const EsGenreTag: React.FC<GenreTag> = ({
    genre,
    onClickGenre,
    active,
    tagStyle,
    tagtextStyle,
    additionalData,
    groupLayout,
    editorialPill,
}) => {
    const { themeStyle } = useThemeContext();
    const styles = dynamicStyles(themeStyle, active, editorialPill);

    return (
        <Box
            style={{
                ...styles.container,
                ...tagStyle,
                ...(editorialPill && {
                    height: 'auto',
                    minHeight: 40,
                    paddingTop: 10,
                    paddingBottom: 10,
                    paddingLeft: 22,
                    paddingRight: 22,
                    boxShadow: active ? '0 10px 30px rgba(255, 201, 101, 0.12)' : undefined,
                }),
                ...(groupLayout &&
                    active && {
                        borderRadius: 9,
                        boxShadow: `0px 0px 2.5px ${theme[themeStyle].gray_sidebar}`,
                        position: 'relative',
                        zIndex: 1,
                    }),
                ...(groupLayout &&
                    !active && {
                        borderRadius: 9,
                        backgroundColor: 'transparent',
                    }),
            }}
            onClick={() => onClickGenre && onClickGenre(genre)}>
            <Typography style={{ ...styles.text, ...tagtextStyle }} sx={{ whiteSpace: 'nowrap' }}>
                {genre}
            </Typography>
            {additionalData && (
                <Typography style={{ ...styles.text, ...tagtextStyle }} sx={{ whiteSpace: 'nowrap' }}>
                    {' ('}
                    {additionalData}
                    {')'}
                </Typography>
            )}
        </Box>
    );
};

const dynamicStyles = (colorScheme: ColorScheme, active?: boolean, editorialPill?: boolean) =>
    StyleSheet.create({
        container: {
            width: 'fit-content',
            cursor: 'pointer',
            height: '32px',
            position: 'relative',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            borderRadius: editorialPill ? 9999 : 100,
            paddingLeft: editorialPill ? 22 : 18,
            paddingRight: editorialPill ? 22 : 18,
            border: 'none',
            backgroundColor: editorialPill
                ? active
                    ? theme[colorScheme].highlight
                    : '#201f1f'
                : active
                  ? theme[colorScheme].lightWhite
                  : theme[colorScheme].dropdown_black,
        },
        text: {
            fontSize: editorialPill ? 13 : 16,
            fontWeight: editorialPill ? '700' : '500',
            fontFamily: FONT_ENUM.MAIN_MEDIUM,
            textAlign: 'left',
            color: editorialPill
                ? active
                    ? theme[colorScheme].true_black
                    : '#adaaaa'
                : active
                  ? theme[colorScheme].dropdown_black
                  : theme[colorScheme].form_label,
        },
    });

export { EsGenreTag };
